import { companyDetailsSectionValidationMap } from 'mittweida/inquiry/steps/company/sections/companyDetails/fieldValidations';
import { completingCompanyDetailsSectionValidationMap } from 'mittweida/inquiry/steps/company/sections/completingCompanyDetailsSection/fieldValidations';

export const mittweidaCompanyDetailsFieldValidation = {
  ...companyDetailsSectionValidationMap,
  ...completingCompanyDetailsSectionValidationMap,
};
